/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class s{constructor(s,i,t){this.visible=s,this.missing=i,this.pending=t}}export{s as GraphicsCorePerformanceInfo};
